var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 711,
    height: 689.39,
    viewBox: "0 0 711 689.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M233.9,642.4l64.7-416,365.6-38.3-64.7,416Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign-up",
    transform: "translate(-144.5 -155.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3094350",
    transform: "translate(-13.4 -29.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(13.4 308.081)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.5,
    cy: 205.2,
    rx: 355.5,
    ry: 205.2,
    transform: "translate(144.5 155.7)",
    fill: "#c2eed3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(35.089 336.332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_4_",
    d: "M208.4,405.8l-61.3-35.5c-3.5-2-3.5-5.3,0-7.2L503.8,157.2a13.771,13.771,0,0,1,12.5,0l61.3,35.5c3.5,2,3.5,5.3,0,7.2L220.9,405.8A13.77,13.77,0,0,1,208.4,405.8Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device",
    transform: "translate(80.541 29.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1341_",
    transform: "translate(147.709 340.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1347_",
    d: "M235.7,309.8l52.7-30.5c5.4-3.2,8.1-7.2,8.1-11.3v-7.4l-54.6-30.8a11.627,11.627,0,0,1-5.3-9.1v-65l-92,53.3v65a11.785,11.785,0,0,0,5.3,9.1L196.4,310C207.2,316.1,224.8,316.1,235.7,309.8Z",
    fill: "#242424"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1608_",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1609_",
    d: "M235.7,309.8l52.7-30.5c5.4-3.2,8.1-7.2,8.1-11.3v-7.4l-54.6-30.8a11.627,11.627,0,0,1-5.3-9.1v-65l-92,53.3v65a11.785,11.785,0,0,0,5.3,9.1L196.4,310C207.2,316.1,224.8,316.1,235.7,309.8Z",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1345_",
    d: "M166.7,285.5v7.2L149.8,283a11.627,11.627,0,0,1-5.3-9.1v-65L162,198.8c.3,4.5.8,9.1,1.1,13.6l-12.4,7.1v50.8a11.368,11.368,0,0,0,5.3,9.1Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1344_",
    d: "M150.9,270.2a11.785,11.785,0,0,0,5.3,9.1l40.1,23.1c10.9,6.3,28.5,6.3,39.4,0l52.8-30.5c10.9-6.3,10.9-16.4,0-22.8L248.4,226a11.627,11.627,0,0,1-5.3-9.1V166.1l-92,53.3v50.8h-.2Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1607_",
    d: "M150.9,270.2a11.785,11.785,0,0,0,5.3,9.1l40.1,23.1c10.9,6.3,28.5,6.3,39.4,0l52.8-30.5c10.9-6.3,10.9-16.4,0-22.8L248.4,226a11.627,11.627,0,0,1-5.3-9.1V166.1l-92,53.3v50.8h-.2Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1343_",
    d: "M258.9,232.4h0l-10.7-6.2a11.627,11.627,0,0,1-5.3-9.1V166.3l-92,53.3v50.8a11.785,11.785,0,0,0,5.3,9.1l10.6,6Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1342_",
    d: "M296.5,260.7v7.4c0,4.1-2.7,8.1-8.1,11.3l-52.7,30.5c-5.3,3-11.9,4.5-18.7,4.7v-7.2c6.8-.2,13.6-1.7,18.7-4.7l52.7-30.5C293.8,268.9,296.5,264.8,296.5,260.7Z",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1610_",
    d: "M296.5,260.7v7.4c0,4.1-2.7,8.1-8.1,11.3l-52.7,30.5c-5.3,3-11.9,4.5-18.7,4.7v-7.2c6.8-.2,13.6-1.7,18.7-4.7l52.7-30.5C293.8,268.9,296.5,264.8,296.5,260.7Z",
    opacity: 0.45
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1340_",
    d: "M150.7,673.6c3.5,2,9.1,1.8,12.7-.3,45.3-26.1,310.8-179.4,356.1-205.5a14.646,14.646,0,0,0,6.5-11.3V168.3c0-4.2-2.7-9.2-6.2-11.2s-9.1-1.8-12.7.3L151,363a14.646,14.646,0,0,0-6.5,11.3v288C144.7,666.6,147.4,671.6,150.7,673.6Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1339_",
    d: "M163.6,673.3,519.7,467.8a14.646,14.646,0,0,0,6.5-11.3V168.3c0-4.2-2.9-5.9-6.5-3.8L163.6,370.1a14.646,14.646,0,0,0-6.5,11.3v288C156.9,673.7,159.9,675.4,163.6,673.3Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    d: "M163.6,673.3,519.7,467.8a14.646,14.646,0,0,0,6.5-11.3V168.3c0-4.2-2.9-5.9-6.5-3.8L163.6,370.1a14.646,14.646,0,0,0-6.5,11.3v288C156.9,673.7,159.9,675.4,163.6,673.3Z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1337_",
    d: "M162.5,680.8a14.292,14.292,0,0,1-11.8-.3,14.4,14.4,0,0,1-6.2-11.2V643l12.4,7.1v26.3C156.9,680.3,159.3,682,162.5,680.8Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1606_",
    d: "M162.5,680.8a14.292,14.292,0,0,1-11.8-.3,14.4,14.4,0,0,1-6.2-11.2V643l12.4,7.1v26.3C156.9,680.3,159.3,682,162.5,680.8Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    d: "M156.9,650.2v26.3c0,4.2,2.9,5.9,6.5,3.8L519.5,474.8a14.646,14.646,0,0,0,6.5-11.3V437.3Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    d: "M156.9,650.2v26.3c0,4.2,2.9,5.9,6.5,3.8L519.5,474.8a14.646,14.646,0,0,0,6.5-11.3V437.3Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1334_",
    d: "M169.3,617.3V385.4a8.5,8.5,0,0,1,3.9-6.8L509.8,184.3c2.1-1.2,3.9-.3,3.9,2.3V418.5a8.5,8.5,0,0,1-3.9,6.8L173.2,619.5C171,620.9,169.3,619.8,169.3,617.3Z",
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1333_",
    d: "M169.3,617.3V385.4a8.5,8.5,0,0,1,3.9-6.8L509.8,184.3c2.1-1.2,3.9-.3,3.9,2.3V418.5a8.5,8.5,0,0,1-3.9,6.8L173.2,619.5C171,620.9,169.3,619.8,169.3,617.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1332_",
    d: "M341.6,551.9a13.551,13.551,0,0,0-6.2,10.7c0,3.9,2.7,5.6,6.2,3.6a13.551,13.551,0,0,0,6.2-10.7C347.6,551.6,344.9,550,341.6,551.9Z",
    fill: "#27debf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1331_",
    d: "M158.9,375a13.742,13.742,0,0,0-2,6.5V650.4l-12.4-7.1.2-268.9a13.742,13.742,0,0,1,2-6.5Z",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1544_",
    d: "M526.1,167.2c-.5-3.3-3.2-4.7-6.5-2.7l-356,205.6a15.383,15.383,0,0,0-4.7,4.8l-12.4-7.1a14.391,14.391,0,0,1,4.7-4.8L507.3,157.5c3.6-2.1,9.4-2.3,12.7-.3C523.1,158.9,525.7,163.3,526.1,167.2Z",
    opacity: 0.4
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_00000023995369099770995190000000710823276395126945_",
    d: "M383.3,744.4l-76.4-44.1c-3.7-2.1-3.7-5.5,0-7.6L523.7,567.5a14.616,14.616,0,0,1,13.2,0l76.4,44.1c3.7,2.1,3.7,5.5,0,7.6L396.5,744.4A14.616,14.616,0,0,1,383.3,744.4Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check_Mark_00000074431934071647444260000008825636023988711312_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M321.6,699.3l65.1,37.6a9.125,9.125,0,0,0,8.5,0L602.6,617.3a9.445,9.445,0,0,0,4.2-7.3v-3a9.132,9.132,0,0,0-4.3-7.3l-65.3-37.6a9.75,9.75,0,0,0-8.5,0L321.5,681.5a9.445,9.445,0,0,0-4.2,7.3v3A9.488,9.488,0,0,0,321.6,699.3Z",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000170253744245785642000000007720966987150713737_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M529.1,561.9c3.2-1.9,6.6-.8,9.8,1.1l62,35.7c3.2,1.9,3.2,4.9,0,6.8L396.7,723.2h0a11.652,11.652,0,0,1-11.7,0l-62-35.7a3.939,3.939,0,0,1,0-6.8h0Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000030463090719422128920000001747600197712912561_",
    d: "M323,685.2a2.328,2.328,0,0,1,.8-3.1L529.9,563.3c2.2-1.3,4.7-.9,8.2,1.1l62,35.7a3.561,3.561,0,0,1,1.4,1.3c.7,1.3-.7,2.3-1.4,2.7L395.9,721.7a9.934,9.934,0,0,1-10,0L323.8,686a1.085,1.085,0,0,1-.8-.8m-1.5.8a3.16,3.16,0,0,0,1.4,1.4L385,723.1a11.652,11.652,0,0,0,11.7,0L600.9,605.4c2.3-1.3,3-3.2,2-4.9a6.126,6.126,0,0,0-2-1.9l-62-35.7c-3.2-1.9-6.6-3-9.8-1.1L323,680.7a3.885,3.885,0,0,0-1.5,5.3Z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M321.5,681.5l1.4-.8a3.939,3.939,0,0,0,0,6.8L385,723.2a11.043,11.043,0,0,0,5.8,1.6h.1V738a8.543,8.543,0,0,1-4.3-1l-65.2-37.6a9.842,9.842,0,0,1-4.3-7.3v-3A10.484,10.484,0,0,1,321.5,681.5Z",
    fill: "#e7e7e7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M398.9,695.7l-20,.8v-6.3l12.5-.6-1.2-27,7-.3Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M392.1,654.4l48.3,27.9-48.3,27.9-48.3-27.9,48.3-27.9m0-1.9-51.6,29.8,51.6,29.8,51.6-29.8-51.6-29.8Z",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M533.3,577.5,410,648.6c-.6.4-.8.9-.3,1.2l2.1,1.2,1.3.7a2.083,2.083,0,0,0,2-.2l123.3-71.1c.6-.4.8-.9.3-1.2l-3.4-1.9A2.845,2.845,0,0,0,533.3,577.5Z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M544.6,584.1,421.3,655.2c-.6.4-.8.9-.3,1.2l2.1,1.2,1.3.7a2.083,2.083,0,0,0,2-.2L549.7,587c.6-.4.8-.9.3-1.2l-3.4-1.9A2.083,2.083,0,0,0,544.6,584.1Z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M555.9,590.6,432.6,661.7c-.6.4-.8.9-.3,1.2l2.1,1.2,1.3.7a2.083,2.083,0,0,0,2-.2L561,593.5c.6-.4.8-.9.3-1.2l-3.4-1.9A2.1,2.1,0,0,0,555.9,590.6Z",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M567.2,597.1,444,668.2c-.6.4-.8.9-.3,1.2l2.1,1.2,1.3.7a2.083,2.083,0,0,0,2-.2L572.3,600c.6-.4.8-.9.3-1.2l-3.4-1.9A2.111,2.111,0,0,0,567.2,597.1Z",
    fill: "#e1e1e1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Lock",
    d: "M649.5,529.1l-5.2,3-14.7-8.5c-10.9-6.3-30-5.5-42.5,1.8-12.6,7.3-13.9,18.3-3.1,24.6l14.7,8.5-5.2,3c-4.5,2.6-5,6.6-1.1,8.9l40.4,23.3c3.3,1.9,8.8,2,13.3.3,23.6-9.1,44-20.8,59.7-34.4a5.042,5.042,0,0,0,2.1-4.1,4.769,4.769,0,0,0-2.6-3.6l-40.4-23.3C660.9,526.2,654,526.5,649.5,529.1Zm21.6,36.3-14.6,8.4L645,564.2c-4,.7-8.1.3-10.9-1.4-4.3-2.5-3.8-6.9,1.2-9.7,5-2.9,12.5-3.2,16.9-.7,2.8,1.6,3.5,4,2.3,6.3Zm-36.2-27.9L608.1,553l-14.7-8.5c-6.4-3.7-5.6-10.2,1.8-14.5s18.7-4.7,25.1-1Z",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M622.7,209.3,282.5,402.2l1.7,229.2v2.3c0,1.1.9,2,2.3,2.4h.1l.2.1c.1,0,.2.1.3.1a4.332,4.332,0,0,0,.5.1h.8a6,6,0,0,0,2-.7l.2-.1h0l6.5-3.7L618,449.9c3.6-2.1,6.5-6.2,6.5-9.3l-1.8-231.3",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M283.7,630.9v0m0,0h0M623,198.2a3.084,3.084,0,0,1,.1,1l.1,9.9-.5.3,1.7,231.2c0,3.1-2.9,7.2-6.5,9.3L297,631.9l-6.5,3.7h0l-.2.1a6,6,0,0,1-2,.7h-.8a.75.75,0,0,1-.5-.1c-.1,0-.2-.1-.3-.1l-.2-.1h-.1a2.839,2.839,0,0,1-2.3-2.4v-2.3l-1.7-229.2-.5.3h0l1.7,229.2v2.1c0,1.4,1.1,2.3,2.5,2.7.1,0,.2.1.3.1s.2.1.4.1.4.1.6.1h.8a7.91,7.91,0,0,0,2.3-.8l.2-.1h0l6.5-3.7,320.9-182c3.8-2.1,6.8-6.5,6.8-9.7l-1.8-241.2v-.6c0-.3,0-.4-.1-.5m-.5-1.1a4.052,4.052,0,0,1,.5.9h0a.519.519,0,0,0-.2-.4,2.185,2.185,0,0,0-.3-.5m-.3-.3.2.2c-.1-.1-.1-.2-.2-.2m-.2-.2.1.1-.1-.1m-4.4,0c-.4.2-.9.4-1.3.6L452.5,290.1l-74.9,42.5L616.3,197.3a8.267,8.267,0,0,1,1.3-.7m3.4-.4a3,3,0,0,1,1,.4.52.52,0,0,0-.4-.2h0a.987.987,0,0,0-.6-.2",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M276.5,383.2c-2,2.2-3.4,4.9-3.4,7a10,10,0,0,1,2-5.3c.5-.6.9-1.2,1.4-1.7M620.4,196c.1,0,.2.1.3.1h0a.774.774,0,0,1-.3-.1m-.9.1a8.723,8.723,0,0,0-3.2,1.1L452.5,290.1l163.8-92.9a9.712,9.712,0,0,1,3.2-1.1h.7c-.2-.1-.4,0-.7,0",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M592.3,221.3a1.457,1.457,0,0,1-1.7-1.6,5.857,5.857,0,0,1,2.9-4.5,3.374,3.374,0,0,1,1.2-.4,1.457,1.457,0,0,1,1.7,1.6,5.857,5.857,0,0,1-2.9,4.5,1.922,1.922,0,0,1-1.2.4m10.4-5.9a1.457,1.457,0,0,1-1.7-1.6,5.857,5.857,0,0,1,2.9-4.5,2.13,2.13,0,0,1,1.2-.4,1.457,1.457,0,0,1,1.7,1.6,5.857,5.857,0,0,1-2.9,4.5,2.843,2.843,0,0,1-1.2.4m10.5-5.9a1.457,1.457,0,0,1-1.7-1.6,5.857,5.857,0,0,1,2.9-4.5,2.13,2.13,0,0,1,1.2-.4,1.457,1.457,0,0,1,1.7,1.6,5.857,5.857,0,0,1-2.9,4.5c-.5.2-.9.3-1.2.4m6.3-13.4a7.668,7.668,0,0,0-1.9.5c-.4.2-.9.4-1.3.6L377.6,332.6,288.7,383a15.61,15.61,0,0,0-4.8,4.4h0a9.486,9.486,0,0,0-2,5.3l.1,9.8.5-.3L622.8,209.3l.5-.3-.1-9.9c0-.4-.1-.7-.1-1V198a1.933,1.933,0,0,0-.5-.9l-.1-.1-.2-.2a.1.1,0,0,1-.1-.1l-.1-.1H622a2.994,2.994,0,0,0-1-.4h0c-.2,0-.4-.1-.6-.1h-.9",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M610.7,193.7a8.723,8.723,0,0,0-3.2,1.1L279.9,380.5a14.436,14.436,0,0,0-3.4,2.7,14.986,14.986,0,0,1,3.4-2.7L607.5,194.8a8.121,8.121,0,0,1,3.2-1.1,4.735,4.735,0,0,1,1.7.1c1.1.3,6,1.7,8,2.2-1.9-.5-6.8-1.9-8-2.2a3.063,3.063,0,0,0-1.7-.1",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M452.5,290.1,288.7,382.9l88.9-50.3,74.9-42.5",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M288.7,382.9c-.5.3-.9.6-1.4.9l.9-.6a2.186,2.186,0,0,1,.5-.3",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M288.7,382.9a2.187,2.187,0,0,0-.5.3,2.186,2.186,0,0,1,.5-.3",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M610.7,193.7a8.723,8.723,0,0,0-3.2,1.1L279.9,380.5a14.436,14.436,0,0,0-3.4,2.7,11.51,11.51,0,0,0-1.4,1.7l8.7,2.5a16.1,16.1,0,0,1,3.4-3.5c.4-.3.9-.6,1.4-.9l163.8-92.9,163.8-92.9a8.121,8.121,0,0,1,3.2-1.1h.7a.749.749,0,0,1,.5.1c-.1,0-.2-.1-.3-.1-1.9-.5-6.8-1.9-8-2.2a1.978,1.978,0,0,0-1.6-.2",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M377.6,332.6,288.7,383a2.187,2.187,0,0,0-.5.3l-.9.6a16.1,16.1,0,0,0-3.4,3.5h0a15.61,15.61,0,0,1,4.8-4.4l88.9-50.4M620.2,196.1a1.268,1.268,0,0,1,.6.1h-.1a.749.749,0,0,0-.5-.1",
    fill: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M282.8,389.1a7.911,7.911,0,0,0-.9,3.5l.1,9.8-8.8-2.6-.1-9.7.1,9.7,6.5,1.9,2.3.7-.1-7.4v-2.4a8.622,8.622,0,0,1,.9-3.5",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M281.9,394.7v.3l.1,7.4h0l-.1-7.7",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M275.2,384.9a8.8,8.8,0,0,0-2,5.3l.1,9.7,8.8,2.6-.1-9.8a7.911,7.911,0,0,1,.9-3.5,8.711,8.711,0,0,1,1.1-1.8l-8.8-2.5",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M283.9,387.3h0a17.4,17.4,0,0,0-1.1,1.8,7.911,7.911,0,0,0-.9,3.5v2.1l.1,7.7-.1-9.8a10.3,10.3,0,0,1,2-5.3h0",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M275.2,384.9l8.7,2.5h0l-8.7-2.5",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M283.9,387.3h0",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M594.7,214.8a2.843,2.843,0,0,0-1.2.4,5.857,5.857,0,0,0-2.9,4.5,1.457,1.457,0,0,0,1.7,1.6,2.843,2.843,0,0,0,1.2-.4,5.857,5.857,0,0,0,2.9-4.5c0-1.2-.7-1.8-1.7-1.6",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M605.1,208.8a2.843,2.843,0,0,0-1.2.4,5.857,5.857,0,0,0-2.9,4.5,1.457,1.457,0,0,0,1.7,1.6,2.843,2.843,0,0,0,1.2-.4,5.857,5.857,0,0,0,2.9-4.5,1.457,1.457,0,0,0-1.7-1.6",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M615.6,202.9a2.843,2.843,0,0,0-1.2.4,5.857,5.857,0,0,0-2.9,4.5,1.457,1.457,0,0,0,1.7,1.6,2.843,2.843,0,0,0,1.2-.4,5.857,5.857,0,0,0,2.9-4.5,1.457,1.457,0,0,0-1.7-1.6",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M273.2,399.9l1.7,230.3a1.7,1.7,0,0,0,.1.7,4.506,4.506,0,0,0,3.6,3.4l7.2,2.1.4.1a2.269,2.269,0,0,0-.4-.1,2.761,2.761,0,0,1-2.1-2.2,2.788,2.788,0,0,0,2.1,2.2,2.269,2.269,0,0,1,.4.1l-.4-.1-7.2-2.1c-2-.6-3.3-1.8-3.6-3.4,0-.2-.1-.5-.1-.7l-1.7-230.3",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M273.2,399.9l1.7,230.3a1.7,1.7,0,0,0,.1.7,4.506,4.506,0,0,0,3.6,3.4l7.2,2.1.4.1a2.269,2.269,0,0,0-.4-.1,2.914,2.914,0,0,1-2.1-2.2v-2.3L282,402.5l-2.3-.7-6.5-1.9h0",
    fill: "#a7a7a7"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(-77.933 -38.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M409.2,375.486a7.949,7.949,0,0,0-.892.149,10.087,10.087,0,0,0-2.686,1.109,15.265,15.265,0,0,0-2.682,1.92,14.33,14.33,0,0,0-2.043,2.24,10.353,10.353,0,0,0-1.28,2.287,5.776,5.776,0,0,0-.433,2.107c.01,1.293.384,2.123,1.109,2.486a2.719,2.719,0,0,0,1.5.189,8.592,8.592,0,0,0,1.953-.488q1.261-.443,2.189-.787a15.422,15.422,0,0,1,1.523-.494,4.011,4.011,0,0,1,.51-.092,1.35,1.35,0,0,1,.385,0,.354.354,0,0,1,.3.4,1.931,1.931,0,0,1-.8,1.394,11.653,11.653,0,0,1-2.026,1.41,4.415,4.415,0,0,1-1.157.5,2.882,2.882,0,0,1-.392.07,1.723,1.723,0,0,1-.383,0,1.491,1.491,0,0,1-.5-.138,2.656,2.656,0,0,0-.277-.141.844.844,0,0,0-.331-.029l-.037,0a1.409,1.409,0,0,0-.5.206l-2.995,1.7a1.007,1.007,0,0,0-.331.337.84.84,0,0,0-.149.434,1.986,1.986,0,0,0,.561,1.383,2.531,2.531,0,0,0,1.466.674,4.571,4.571,0,0,0,1.154.012,7.851,7.851,0,0,0,1.059-.191,11.79,11.79,0,0,0,2.838-1.2,19.306,19.306,0,0,0,2.822-1.945,15.336,15.336,0,0,0,2.231-2.254,10.245,10.245,0,0,0,1.463-2.385,5.776,5.776,0,0,0,.514-2.35,3.723,3.723,0,0,0-.325-1.668,1.648,1.648,0,0,0-.947-.818,3.06,3.06,0,0,0-1.31-.108c-.085.009-.172.02-.261.034a12.062,12.062,0,0,0-2.2.618c-.843.311-1.546.565-2.112.768a9.866,9.866,0,0,1-1.359.4c-.1.019-.184.032-.264.041a.987.987,0,0,1-.476-.037.444.444,0,0,1-.216-.444,1.324,1.324,0,0,1,.185-.677,3.239,3.239,0,0,1,.5-.636,6.559,6.559,0,0,1,.705-.583c.271-.188.547-.365.839-.528a4.485,4.485,0,0,1,1.007-.45,3.042,3.042,0,0,1,.446-.087,1.455,1.455,0,0,1,.239-.007,1.043,1.043,0,0,1,.427.087,2.029,2.029,0,0,0,.221.1.961.961,0,0,0,.4.043h.017a1.429,1.429,0,0,0,.491-.194l3-1.7a1.015,1.015,0,0,0,.332-.337.837.837,0,0,0,.148-.434,1.759,1.759,0,0,0-.538-1.211,2.508,2.508,0,0,0-1.407-.653,4.519,4.519,0,0,0-1.232-.021",
    transform: "translate(77.946 37.986)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M424.457,367.423a.674.674,0,0,0-.256.09l-3,1.7a1.188,1.188,0,0,0-.433.427,1,1,0,0,0-.182.534l.111,14.577a.315.315,0,0,0,.185.325.363.363,0,0,0,.18.024.625.625,0,0,0,.252-.09l2.995-1.7a1.266,1.266,0,0,0,.432-.427,1.008,1.008,0,0,0,.182-.534l-.11-14.583a.321.321,0,0,0-.185-.325.357.357,0,0,0-.176-.023",
    transform: "translate(72.444 40.012)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M440.554,357.617a7.735,7.735,0,0,0-.767.123,9.891,9.891,0,0,0-2.882,1.172,15.147,15.147,0,0,0-2.949,2.16,14.873,14.873,0,0,0-2.194,2.574,12.558,12.558,0,0,0-1.4,2.75,9,9,0,0,0-.533,2.675c-.022.66-.029,1.344-.028,2.054s.024,1.36.061,1.961a4.517,4.517,0,0,0,.577,2.038,2.6,2.6,0,0,0,1.422,1.155,3.842,3.842,0,0,0,1.662.148q.268-.028.556-.085a9.851,9.851,0,0,0,2.94-1.183,15.609,15.609,0,0,0,2.8-2.017,15.187,15.187,0,0,0,2.246-2.51,11.993,11.993,0,0,0,1.491-2.807,8.174,8.174,0,0,0,.534-2.913l-.023-2.886a.316.316,0,0,0-.185-.325.384.384,0,0,0-.179-.023.725.725,0,0,0-.26.09l-5.535,3.147a1.248,1.248,0,0,0-.433.428.97.97,0,0,0-.175.527l.013,2.394a.327.327,0,0,0,.191.325.357.357,0,0,0,.179.025.645.645,0,0,0,.253-.091l1.92-1.092a3.569,3.569,0,0,1-.218,1.285,4.324,4.324,0,0,1-.614,1.113,5.428,5.428,0,0,1-.911.95,7.6,7.6,0,0,1-1.119.775,4.1,4.1,0,0,1-1.291.517c-.052.008-.1.015-.15.019a1.232,1.232,0,0,1-.725-.1,1.13,1.13,0,0,1-.512-.545,2.828,2.828,0,0,1-.224-.873c-.014-.184-.035-.452-.05-.795s-.027-.7-.031-1.073,0-.726.006-1.077a7.792,7.792,0,0,1,.051-.848,7.184,7.184,0,0,1,.218-1.12,4.776,4.776,0,0,1,.491-1.117,5.409,5.409,0,0,1,.847-1.059,6.418,6.418,0,0,1,1.3-.959,4.335,4.335,0,0,1,1.5-.6,1.1,1.1,0,0,1,.17-.005,1.628,1.628,0,0,1,.874.247c.126.067.252.133.386.193a.338.338,0,0,0,.183.027.955.955,0,0,0,.354-.131l3.043-1.724a1.078,1.078,0,0,0,.36-.356.606.606,0,0,0,.135-.428,2.123,2.123,0,0,0-.555-1.3,2.645,2.645,0,0,0-1.408-.763,4.28,4.28,0,0,0-1.415-.058",
    transform: "translate(70.12 42.493)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M465.3,342.463a.626.626,0,0,0-.251.091l-2.995,1.7a1.281,1.281,0,0,0-.433.427,1.007,1.007,0,0,0-.182.534l.056,7.628L456.2,348.1a.8.8,0,0,0-.313-.142.5.5,0,0,0-.178-.011,1.175,1.175,0,0,0-.448.167l-2.382,1.348a1.275,1.275,0,0,0-.433.427.939.939,0,0,0-.176.533l.1,14.583a.315.315,0,0,0,.185.325.364.364,0,0,0,.181.025.667.667,0,0,0,.257-.092l3-1.7a1.239,1.239,0,0,0,.433-.427,1.052,1.052,0,0,0,.182-.533l-.062-7.627,5.3,4.745a.755.755,0,0,0,.313.142.513.513,0,0,0,.178.01,1.178,1.178,0,0,0,.448-.167l2.376-1.352a1.151,1.151,0,0,0,.432-.427.943.943,0,0,0,.182-.534l-.1-14.578a.318.318,0,0,0-.191-.325.375.375,0,0,0-.181-.024",
    transform: "translate(64.453 46.307)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M494.269,325.91a.713.713,0,0,0-.259.088l-3,1.7a1.32,1.32,0,0,0-.432.427.99.99,0,0,0-.176.533l.061,8.915a4.771,4.771,0,0,1-.656,2.5,5.3,5.3,0,0,1-2.038,1.932,3.7,3.7,0,0,1-1.366.513,1.13,1.13,0,0,1-.687-.117c-.451-.255-.683-.835-.692-1.741l-.067-8.915a.312.312,0,0,0-.185-.325.354.354,0,0,0-.176-.023.682.682,0,0,0-.256.09l-3,1.7a1.235,1.235,0,0,0-.433.427,1,1,0,0,0-.182.533l.065,9.006a5.1,5.1,0,0,0,.529,2.468,2.465,2.465,0,0,0,1.433,1.2,3.476,3.476,0,0,0,1.43.119,5.631,5.631,0,0,0,.77-.138,11.108,11.108,0,0,0,2.842-1.188,16.512,16.512,0,0,0,2.809-2.018,13.811,13.811,0,0,0,2.192-2.483,11.235,11.235,0,0,0,1.419-2.821,9.268,9.268,0,0,0,.479-3.04l-.065-9.006a.321.321,0,0,0-.185-.325.4.4,0,0,0-.18-.021",
    transform: "translate(57.276 50.482)",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M507.665,326.078l-.023-3.565,2.812-1.6a3.455,3.455,0,0,1,1.292-.482,1.472,1.472,0,0,1,.3,0c.422.04.637.373.637,1.009a2.624,2.624,0,0,1-.615,1.719,5.408,5.408,0,0,1-1.583,1.321l-2.818,1.6m6.458-10.085a5.492,5.492,0,0,0-.947.192,12,12,0,0,0-2.634,1.167L504,321.067a1.277,1.277,0,0,0-.432.427.988.988,0,0,0-.176.532l.1,14.578a.326.326,0,0,0,.185.325.39.39,0,0,0,.184.024.659.659,0,0,0,.255-.091l2.995-1.7a1.32,1.32,0,0,0,.432-.427,1.013,1.013,0,0,0,.183-.538l-.035-4.6,2.927-1.659a16.307,16.307,0,0,0,2.625-1.834,12.6,12.6,0,0,0,1.981-2.122,9.1,9.1,0,0,0,1.256-2.369,7.487,7.487,0,0,0,.432-2.579,3.982,3.982,0,0,0-.464-2.045,2,2,0,0,0-1.281-.941,3.067,3.067,0,0,0-1.048-.052",
    transform: "translate(51.561 52.988)",
    fill: "#969696"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(-252 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M373.682,553.89l-.027.012.027-.012m.017-.008-.017.008.017-.008m.12-.061,0,0-.02.01-.074.037-.023.012.021-.01.079-.04.006,0,.014-.008m-8.534-22.714a3.07,3.07,0,0,0-.53,1.1l0,.016c0,.019-.007.037-.01.056l-.007.036-.005.038c0,.017-.005.034-.006.051l0,.021c0,.021,0,.043-.005.064s0,.055,0,.082l.141,18.687a2.474,2.474,0,0,0,1.861,2.073l3.509.971a4.125,4.125,0,0,0,1.26.114c.1-.006.192-.014.289-.024a6.227,6.227,0,0,0,1.881-.488,2.023,2.023,0,0,1-.61.177l-.06,0a.781.781,0,0,1-.92-.833l-.115-14.9-.026-3.783a1.556,1.556,0,0,1,.019-.251,2.9,2.9,0,0,1,.511-1.161l-7.169-2.044",
    transform: "translate(246.945 83.988)",
    fill: "#2ba157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M562.666,419.2a5.542,5.542,0,0,0-2.073.615L366.539,529.96a4,4,0,0,0-1.257,1.146h0l.007-.009,7.162,2.053a4.108,4.108,0,0,1,1.295-1.2L567.794,421.811a2.325,2.325,0,0,1,.878-.31,1.05,1.05,0,0,1,.505.058l.042.018.011.005a.718.718,0,0,1,.382.483,2.408,2.408,0,0,0-1.168-1.519l-.006,0-.066-.038-.016-.008c-.02-.012-.041-.022-.062-.033l-.021-.011-.06-.03-.026-.011-.059-.027-.027-.011-.058-.024-.032-.012-.055-.021-.038-.013-.05-.017-.09-.026-3.154-.873-.355-.1a4.5,4.5,0,0,0-1.6-.087",
    transform: "translate(246.945 83.988)",
    fill: "#5ed48a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M440.986,501.969a3.52,3.52,0,0,0-1.266.494l-2.193,1.244.023,2.84,2.194-1.244a5.234,5.234,0,0,0,1.379-1.081,2.089,2.089,0,0,0,.506-1.435c-.006-.552-.178-.832-.519-.825-.04,0-.081,0-.124.007m62.6-35.567a3.47,3.47,0,0,0-1.259.493l-2.194,1.244.014,2.848,2.2-1.252a5.2,5.2,0,0,0,1.371-1.08,2.093,2.093,0,0,0,.514-1.436c-.005-.552-.178-.832-.528-.824-.038,0-.079,0-.121.007m-67.8,46.9a.218.218,0,0,1-.121-.021.221.221,0,0,1-.125-.213l-.066-9.663a.6.6,0,0,1,.113-.352.849.849,0,0,1,.293-.286l3.906-2.218a5.862,5.862,0,0,1,2.16-.827,1.775,1.775,0,0,1,.723.056q1,.31,1.007,1.851a4.91,4.91,0,0,1-.492,2.15,6.824,6.824,0,0,1-1.488,1.993l2.117,2.507.053.136a.585.585,0,0,1-.1.287.66.66,0,0,1-.235.23l-1.285.738a.881.881,0,0,1-.325.124.261.261,0,0,1-.124-.013.542.542,0,0,1-.209-.148l-2.008-2.356-2.012,1.14.022,3.493a.639.639,0,0,1-.121.353.819.819,0,0,1-.284.278l-1.229.7a.423.423,0,0,1-.168.065m10.15-5.771a.267.267,0,0,1-.12-.015.213.213,0,0,1-.116-.215l-.075-9.662a.713.713,0,0,1,.122-.36.809.809,0,0,1,.284-.278l6.528-3.713a.5.5,0,0,1,.176-.06.213.213,0,0,1,.113.016.2.2,0,0,1,.125.214l.009,1.062a.641.641,0,0,1-.123.36.807.807,0,0,1-.283.278l-4.9,2.783.02,2.38,4.561-2.592a.414.414,0,0,1,.167-.062.244.244,0,0,1,.122.018.2.2,0,0,1,.124.214l.01,1.062a.694.694,0,0,1-.122.353.891.891,0,0,1-.285.285l-4.561,2.592.012,2.487,5.025-2.853a.454.454,0,0,1,.172-.063.184.184,0,0,1,.109.019.2.2,0,0,1,.124.214l.009,1.063a.675.675,0,0,1-.113.352.855.855,0,0,1-.292.279l-6.647,3.781a.492.492,0,0,1-.177.061m10.827-6.429a2.227,2.227,0,0,1-1.012-.1,1.6,1.6,0,0,1-.862-.81,3.471,3.471,0,0,1-.336-1.468c-.013-.183-.023-.387-.029-.614s-.012-.459-.016-.7,0-.475,0-.7.011-.448.017-.647a6.413,6.413,0,0,1,.326-1.828,6.909,6.909,0,0,1,.872-1.764,8.609,8.609,0,0,1,1.407-1.63,10.934,10.934,0,0,1,1.962-1.411,7.114,7.114,0,0,1,2.173-.894c.123-.022.241-.039.353-.051a2.229,2.229,0,0,1,1.019.084,1.234,1.234,0,0,1,.718.563,1.949,1.949,0,0,1,.246.711.558.558,0,0,1-.114.359.9.9,0,0,1-.292.279l-1.229.7a.465.465,0,0,1-.191.077.2.2,0,0,1-.077-.006l-.144-.091c-.021-.026-.078-.084-.165-.167a.725.725,0,0,0-.41-.191,1.637,1.637,0,0,0-.486-.008c-.078.008-.161.02-.249.035a4,4,0,0,0-1.137.481,5.261,5.261,0,0,0-1.815,1.637,3.835,3.835,0,0,0-.714,2.032c-.019.392-.025.8-.026,1.236s.02.834.046,1.2c.031.812.282,1.282.738,1.39a1.384,1.384,0,0,0,.483.028,3.659,3.659,0,0,0,1.341-.5,6.541,6.541,0,0,0,1.024-.71,4.675,4.675,0,0,0,.811-.843,3.843,3.843,0,0,0,.523-1.012,3.74,3.74,0,0,0,.186-1.2l-.007-.112-1.848,1.044a.443.443,0,0,1-.169.06.244.244,0,0,1-.12-.015.222.222,0,0,1-.124-.214l-.009-1.062a.691.691,0,0,1,.121-.353.864.864,0,0,1,.293-.286l3.487-1.983a.408.408,0,0,1,.157-.054.229.229,0,0,1,.123.018.2.2,0,0,1,.124.213l.019,1.643a6.226,6.226,0,0,1-.274,1.815,7.216,7.216,0,0,1-.859,1.792,9.129,9.129,0,0,1-1.431,1.675,10.991,10.991,0,0,1-2.019,1.452,7.151,7.151,0,0,1-2,.834,3.827,3.827,0,0,1-.41.067m9.165-4.929a.243.243,0,0,1-.12-.015.207.207,0,0,1-.124-.214l-.067-9.663a.6.6,0,0,1,.113-.352.814.814,0,0,1,.293-.286l1.221-.7a.492.492,0,0,1,.175-.06.207.207,0,0,1,.114.016.2.2,0,0,1,.124.213l.075,9.662a.677.677,0,0,1-.121.353.785.785,0,0,1-.285.285l-1.229.7a.439.439,0,0,1-.169.059m5.4-8a1.861,1.861,0,0,1-.888-.085,1.035,1.035,0,0,1-.557-.53,2.473,2.473,0,0,1-.192-1.057,3.784,3.784,0,0,1,.294-1.413,6.645,6.645,0,0,1,.831-1.449,9.069,9.069,0,0,1,1.256-1.351,9.2,9.2,0,0,1,1.587-1.131,6.574,6.574,0,0,1,1.784-.747,4.884,4.884,0,0,1,.518-.085,2.424,2.424,0,0,1,.778.027,1.283,1.283,0,0,1,.785.449,1.351,1.351,0,0,1,.307.748.563.563,0,0,1-.114.359.974.974,0,0,1-.292.279l-1.065.6a.939.939,0,0,1-.317.128.218.218,0,0,1-.068,0,.466.466,0,0,1-.236-.131.973.973,0,0,0-.69-.261.992.992,0,0,0-.131.006,3.551,3.551,0,0,0-1.251.5,5.456,5.456,0,0,0-.744.51,4.524,4.524,0,0,0-.622.59,2.842,2.842,0,0,0-.412.618,1.352,1.352,0,0,0-.151.6.627.627,0,0,0,.151.473.564.564,0,0,0,.481.106,5,5,0,0,0,.906-.223c.377-.125.841-.28,1.395-.48a10.123,10.123,0,0,1,1.578-.435c.089-.015.174-.026.255-.035a2.113,2.113,0,0,1,.822.05,1.055,1.055,0,0,1,.628.494,2,2,0,0,1,.214.977,3.677,3.677,0,0,1-.3,1.421,6.188,6.188,0,0,1-.852,1.479,9.765,9.765,0,0,1-1.377,1.435,11.824,11.824,0,0,1-1.835,1.284,8.165,8.165,0,0,1-1.622.716,4.42,4.42,0,0,1-.852.183,2.978,2.978,0,0,1-.522.011,1.573,1.573,0,0,1-.972-.373,1.415,1.415,0,0,1-.414-.963.521.521,0,0,1,.114-.36.9.9,0,0,1,.292-.278l1.056-.6a.981.981,0,0,1,.338-.134.264.264,0,0,1,.056,0,.3.3,0,0,1,.236.138,1.147,1.147,0,0,0,.261.242.7.7,0,0,0,.406.114,1.229,1.229,0,0,0,.145-.007,2.9,2.9,0,0,0,.5-.111,5.56,5.56,0,0,0,.966-.449c.3-.173.6-.367.877-.567a5.48,5.48,0,0,0,.739-.645,3.662,3.662,0,0,0,.513-.684,1.36,1.36,0,0,0,.191-.694.4.4,0,0,0-.217-.417.846.846,0,0,0-.39-.032,2.066,2.066,0,0,0-.251.043,8.233,8.233,0,0,0-1.071.325c-.43.144-.92.309-1.471.488a8.152,8.152,0,0,1-1.329.331l-.063.007m7.808-8.137a.223.223,0,0,1-.113-.016.207.207,0,0,1-.123-.221l-.009-1.063a.63.63,0,0,1,.121-.353.827.827,0,0,1,.284-.278l7.5-4.261a.458.458,0,0,1,.17-.06.258.258,0,0,1,.12.016.208.208,0,0,1,.124.213l.009,1.063a.706.706,0,0,1-.121.353.835.835,0,0,1-.285.285l-2.731,1.549.062,8.2a.677.677,0,0,1-.121.353.8.8,0,0,1-.285.286l-1.229.7a.459.459,0,0,1-.173.06.235.235,0,0,1-.116-.016.2.2,0,0,1-.124-.214l-.061-8.2-2.724,1.555a.493.493,0,0,1-.176.061m9.9,3.01a.224.224,0,0,1-.119-.017.2.2,0,0,1-.124-.214l-.075-9.662a.706.706,0,0,1,.121-.353.834.834,0,0,1,.285-.285l6.535-3.706a.4.4,0,0,1,.171-.064.3.3,0,0,1,.12.012.24.24,0,0,1,.123.221v1.063a.615.615,0,0,1-.113.352.841.841,0,0,1-.292.279l-4.89,2.782.012,2.381,4.561-2.592a.5.5,0,0,1,.176-.06.213.213,0,0,1,.113.016.2.2,0,0,1,.124.214l.01,1.062a.61.61,0,0,1-.122.353.785.785,0,0,1-.285.285l-4.561,2.592.02,2.486,5.017-2.852a.458.458,0,0,1,.17-.06.267.267,0,0,1,.119.015.217.217,0,0,1,.125.214v1.064a.6.6,0,0,1-.113.352.757.757,0,0,1-.293.286l-6.646,3.774a.422.422,0,0,1-.17.062m9.353-5.309a.208.208,0,0,1-.122-.022c-.087-.026-.125-.1-.124-.213l-.075-9.662a.7.7,0,0,1,.121-.353.834.834,0,0,1,.285-.285l3.914-2.219a5.843,5.843,0,0,1,2.159-.827,1.784,1.784,0,0,1,.725.056q.984.312,1.007,1.851a4.941,4.941,0,0,1-.5,2.151,6.787,6.787,0,0,1-1.48,1.992l2.117,2.507.045.137a.524.524,0,0,1-.1.293.7.7,0,0,1-.235.231l-1.284.73a.947.947,0,0,1-.331.125.245.245,0,0,1-.118-.014.424.424,0,0,1-.209-.148l-2.008-2.356-2.021,1.148.031,3.485a.706.706,0,0,1-.121.353.818.818,0,0,1-.284.278l-1.23.7a.45.45,0,0,1-.166.059m70.28-56.232a2.286,2.286,0,0,0-.872.307L373.749,531.954a4.108,4.108,0,0,0-1.295,1.2,2.9,2.9,0,0,0-.511,1.161,1.556,1.556,0,0,0-.019.251l.026,3.783.115,14.9a.79.79,0,0,0,.971.829,2.293,2.293,0,0,0,.874-.307L567.963,443.628a3.748,3.748,0,0,0,1.8-2.358,1.539,1.539,0,0,0,.019-.25l-.133-18.688a1.155,1.155,0,0,0-.035-.267.718.718,0,0,0-.382-.483l-.011-.005-.042-.018a1.055,1.055,0,0,0-.5-.056",
    transform: "translate(246.945 83.988)",
    fill: "#9be4b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M679.5,585.818l1.1,14.666,78.852-44.157-3-14.193Z",
    fill: "#9be4b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(-33.8 118.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217-2",
    "data-name": "Path 217",
    d: "M403.715,375.47a3.775,3.775,0,0,0-.423.071,4.78,4.78,0,0,0-1.273.526,7.235,7.235,0,0,0-1.271.91,6.793,6.793,0,0,0-.968,1.062,4.908,4.908,0,0,0-.607,1.084,2.737,2.737,0,0,0-.205,1c0,.613.182,1.006.526,1.179a1.289,1.289,0,0,0,.711.09,4.072,4.072,0,0,0,.926-.231q.6-.21,1.037-.373a7.307,7.307,0,0,1,.722-.234,1.9,1.9,0,0,1,.242-.044.64.64,0,0,1,.183,0,.168.168,0,0,1,.141.189.915.915,0,0,1-.379.661,5.523,5.523,0,0,1-.96.668,2.093,2.093,0,0,1-.548.236,1.368,1.368,0,0,1-.186.033.819.819,0,0,1-.181,0,.706.706,0,0,1-.237-.066,1.26,1.26,0,0,0-.131-.067.4.4,0,0,0-.157-.014l-.018,0a.668.668,0,0,0-.236.1l-1.42.8a.478.478,0,0,0-.157.16.4.4,0,0,0-.071.206.941.941,0,0,0,.266.655,1.2,1.2,0,0,0,.695.319,2.169,2.169,0,0,0,.547.006,3.721,3.721,0,0,0,.5-.091,5.588,5.588,0,0,0,1.345-.571,9.151,9.151,0,0,0,1.338-.922,7.268,7.268,0,0,0,1.057-1.068,4.855,4.855,0,0,0,.694-1.131,2.738,2.738,0,0,0,.244-1.114,1.765,1.765,0,0,0-.154-.79.781.781,0,0,0-.449-.388,1.451,1.451,0,0,0-.621-.051c-.04,0-.082.01-.124.016a5.719,5.719,0,0,0-1.043.293c-.4.147-.733.268-1,.364a4.678,4.678,0,0,1-.644.188c-.045.009-.087.015-.125.019a.468.468,0,0,1-.225-.018.21.21,0,0,1-.1-.211.628.628,0,0,1,.088-.321,1.536,1.536,0,0,1,.238-.3,3.1,3.1,0,0,1,.334-.276c.129-.089.259-.173.4-.25a2.126,2.126,0,0,1,.477-.213,1.44,1.44,0,0,1,.212-.041.692.692,0,0,1,.113,0,.494.494,0,0,1,.2.041.963.963,0,0,0,.1.047.455.455,0,0,0,.191.02h.008a.678.678,0,0,0,.233-.092l1.42-.807a.481.481,0,0,0,.157-.16.4.4,0,0,0,.07-.206.834.834,0,0,0-.255-.574,1.189,1.189,0,0,0-.667-.309,2.142,2.142,0,0,0-.584-.01",
    transform: "translate(77.946 14.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218-2",
    "data-name": "Path 218",
    d: "M422.423,367.422a.319.319,0,0,0-.121.043l-1.42.807a.563.563,0,0,0-.205.2.476.476,0,0,0-.086.253l.053,6.909a.149.149,0,0,0,.088.154.172.172,0,0,0,.085.011.3.3,0,0,0,.119-.043l1.42-.8a.6.6,0,0,0,.2-.2.478.478,0,0,0,.086-.253l-.052-6.912a.152.152,0,0,0-.088-.154.169.169,0,0,0-.084-.011",
    transform: "translate(63.863 19.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219-2",
    "data-name": "Path 219",
    d: "M434.9,357.6a3.668,3.668,0,0,0-.364.058,4.688,4.688,0,0,0-1.366.555,7.178,7.178,0,0,0-1.4,1.024,7.05,7.05,0,0,0-1.04,1.22,5.952,5.952,0,0,0-.662,1.3,4.267,4.267,0,0,0-.253,1.268c-.011.313-.014.637-.013.974s.011.645.029.929a2.141,2.141,0,0,0,.273.966,1.234,1.234,0,0,0,.674.548,1.82,1.82,0,0,0,.788.07q.127-.013.263-.04a4.67,4.67,0,0,0,1.393-.561,7.4,7.4,0,0,0,1.325-.956,7.2,7.2,0,0,0,1.065-1.19,5.685,5.685,0,0,0,.707-1.331,3.874,3.874,0,0,0,.253-1.381l-.011-1.368a.15.15,0,0,0-.088-.154.182.182,0,0,0-.085-.011.344.344,0,0,0-.123.043l-2.624,1.491a.592.592,0,0,0-.205.2.46.46,0,0,0-.083.25l.006,1.135a.155.155,0,0,0,.091.154.169.169,0,0,0,.085.012.306.306,0,0,0,.12-.043l.91-.518a1.692,1.692,0,0,1-.1.609,2.049,2.049,0,0,1-.291.528,2.571,2.571,0,0,1-.432.45,3.6,3.6,0,0,1-.531.367,1.943,1.943,0,0,1-.612.245l-.071.009a.584.584,0,0,1-.344-.049.536.536,0,0,1-.242-.258,1.34,1.34,0,0,1-.106-.414c-.007-.087-.017-.214-.024-.377s-.013-.333-.015-.509,0-.344,0-.51a3.693,3.693,0,0,1,.024-.4,3.4,3.4,0,0,1,.1-.531,2.263,2.263,0,0,1,.232-.53,2.563,2.563,0,0,1,.4-.5,3.042,3.042,0,0,1,.618-.454,2.054,2.054,0,0,1,.711-.284.52.52,0,0,1,.08,0,.772.772,0,0,1,.414.117c.06.032.119.063.183.091a.16.16,0,0,0,.087.013.453.453,0,0,0,.168-.062l1.442-.817a.511.511,0,0,0,.171-.169.287.287,0,0,0,.064-.2,1.006,1.006,0,0,0-.263-.618,1.254,1.254,0,0,0-.667-.362,2.028,2.028,0,0,0-.671-.028",
    transform: "translate(57.914 26.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220-2",
    "data-name": "Path 220",
    d: "M458.446,342.462a.3.3,0,0,0-.119.043l-1.42.8a.607.607,0,0,0-.205.2.477.477,0,0,0-.086.253l.027,3.616-2.507-2.247a.378.378,0,0,0-.149-.067.235.235,0,0,0-.084-.005.556.556,0,0,0-.212.079l-1.129.639a.6.6,0,0,0-.205.2.445.445,0,0,0-.083.253l.049,6.912a.149.149,0,0,0,.088.154.173.173,0,0,0,.086.012.317.317,0,0,0,.122-.044l1.42-.807a.587.587,0,0,0,.205-.2.5.5,0,0,0,.086-.253l-.029-3.615,2.51,2.249a.357.357,0,0,0,.148.067.243.243,0,0,0,.084,0,.558.558,0,0,0,.212-.079l1.126-.641a.546.546,0,0,0,.2-.2.447.447,0,0,0,.086-.253l-.05-6.91a.151.151,0,0,0-.091-.154.177.177,0,0,0-.086-.011",
    transform: "translate(43.41 35.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    d: "M487.148,325.909a.338.338,0,0,0-.123.042l-1.42.807a.625.625,0,0,0-.2.2.469.469,0,0,0-.084.253l.029,4.226a2.262,2.262,0,0,1-.311,1.186,2.514,2.514,0,0,1-.966.916,1.756,1.756,0,0,1-.648.243.536.536,0,0,1-.326-.056c-.214-.121-.324-.4-.328-.825l-.032-4.226a.148.148,0,0,0-.088-.154.168.168,0,0,0-.083-.011.324.324,0,0,0-.122.043l-1.42.807a.585.585,0,0,0-.205.2.474.474,0,0,0-.086.253l.031,4.269a2.417,2.417,0,0,0,.251,1.17,1.169,1.169,0,0,0,.679.57,1.648,1.648,0,0,0,.678.056,2.669,2.669,0,0,0,.365-.066,5.265,5.265,0,0,0,1.347-.563,7.825,7.825,0,0,0,1.331-.957,6.548,6.548,0,0,0,1.039-1.177,5.326,5.326,0,0,0,.673-1.337,4.393,4.393,0,0,0,.227-1.441l-.031-4.269a.152.152,0,0,0-.088-.154.189.189,0,0,0-.085-.01",
    transform: "translate(25.038 46.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222-2",
    "data-name": "Path 222",
    d: "M505.416,320.762l-.011-1.69,1.333-.758a1.638,1.638,0,0,1,.612-.228.7.7,0,0,1,.141,0c.2.019.3.177.3.478a1.243,1.243,0,0,1-.291.815,2.563,2.563,0,0,1-.75.626l-1.336.759m3.061-4.78a2.6,2.6,0,0,0-.449.091,5.684,5.684,0,0,0-1.248.553l-3.1,1.76a.605.605,0,0,0-.2.2.468.468,0,0,0-.084.252l.05,6.91a.155.155,0,0,0,.088.154.184.184,0,0,0,.087.011.313.313,0,0,0,.121-.043l1.42-.8a.626.626,0,0,0,.2-.2.48.48,0,0,0,.087-.255l-.017-2.182,1.387-.786a7.732,7.732,0,0,0,1.244-.869,5.976,5.976,0,0,0,.939-1.006,4.317,4.317,0,0,0,.6-1.123,3.55,3.55,0,0,0,.2-1.222,1.888,1.888,0,0,0-.22-.969.95.95,0,0,0-.607-.446,1.454,1.454,0,0,0-.5-.025",
    transform: "translate(10.41 52.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M356.869,504.665l197.26-112.256v22.974L356.869,527.319Z",
    transform: "translate(0 -30)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M356.869,504.665l197.26-112.256v22.974L356.869,527.319Z",
    transform: "translate(0 2)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M356.869,504.665l197.26-112.256v22.974L356.869,527.319Z",
    transform: "translate(0 -62)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Last_Name",
    "data-name": "Last Name",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 378.062, 478.025)",
    fill: "#242424",
    fontSize: 11,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Last Name")), /*#__PURE__*/React.createElement("text", {
    id: "Email_",
    "data-name": "Email *",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 378.062, 510.025)",
    fill: "#242424",
    fontSize: 11,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Email *")), /*#__PURE__*/React.createElement("text", {
    id: "First_Name_",
    "data-name": "First Name *",
    transform: "matrix(0.883, -0.469, 0.469, 0.883, 378.062, 446.025)",
    fill: "#242424",
    fontSize: 11,
    fontFamily: "Roboto-Regular, Roboto",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "First Name *")), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 93.5,
    cy: 23.5,
    rx: 93.5,
    ry: 23.5,
    transform: "translate(625.5 652.707)",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(7.541 -21.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M677.535,679.792l-5.261,17.98-38.538-16.143c5.937-7.792,29.061-.414,29.537-.263l.009,0,1.841-1.623,1.619-1.428C671.06,678.156,677.535,679.792,677.535,679.792Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M668.12,684.8c-1.258-2.295-4.838-3.429-4.838-3.429l1.841-1.623A7.256,7.256,0,0,1,668.12,684.8Z",
    fill: "#181f21"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M693.183,526.774l-1.955,19.239s13.5,15.984,33.29,10.944c19.138-4.873,31.5-13.638,31.5-13.638l-4.274-22.614S713.958,517.344,693.183,526.774Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M677.375,680.1c3.837-7.865,12.843-22.2,16.7-34.837a220.575,220.575,0,0,0,7.877-37.267c15.861-25.357,23.381-54.9,23.381-54.9-6.287-14.058-32.516-15.786-32.516-15.786l-12.89,70.781-13.18,70.235C671.272,679.7,673.588,680.817,677.375,680.1Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M770.519,677.315c-.4-8.181-1.1-24.142-1.757-30.995-.386-4.035-.445-34.606-7.115-40.872,0,0,1.809-53.546-9.907-84.743l-31.6,8.629L742.969,614.3,759.646,680.1C763.987,680.239,766.549,680.021,770.519,677.315Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M775.891,697.772H736.312c4.74-9.041,22.235-12.563,22.235-12.563l.627-2.922.471-2.188c3.767-2.112,10.873-2.784,10.873-2.784Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M768.366,687.543c-3.669-3-9.819-2.334-9.819-2.334l.627-2.922C766.943,682.718,768.366,687.543,768.366,687.543Z",
    fill: "#181f21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M751.738,520.7a59.479,59.479,0,0,1-27.22,8.44,102.853,102.853,0,0,1-18.228-.555c-4.216-.454-8.574-1.09-13.106-1.815L682.191,424.989l13.341-5.6.005,0,18.077-6.084,20.4-.042Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M701.949,430.374l.952,56.37,8.782,15.115,6.127-17.686-12.462-54.306Z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M698.61,426.4l5.373,7.514,3.21-9.515-5.512-3.056Z",
    fill: "#293235"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M713.613,413.3c-4.221,5.916-9.9,8.258-16.357,8.689l-1.954-5.7-2.488-7.253a31.293,31.293,0,0,1,3.615-6.114c2.663-3.505,6.741-7.159,12.036-6.838Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M706.693,398.89s-1.6,12.676-11.391,17.4l-2.488-7.253a31.293,31.293,0,0,1,3.615-6.114Z",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M672.755,366.883v37.8a8.6,8.6,0,0,0,9.261,8.585c9.6-.771,24-4.406,29.819-18.669C720.923,372.337,693.2,351.433,672.755,366.883Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M672.755,382.1l-3.826,10.839a2.418,2.418,0,0,0,1.485,3.088l2.341.817S676.177,393.812,672.755,382.1Z",
    fill: "#ffb797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M672.755,369.752a11.648,11.648,0,0,1-7.765-11.992c1.089-17.661,34.113-7.036,46.757-1.515,14.341,6.261,8.988,29.993,5.656,36.961a17.856,17.856,0,0,1-5.269,6.4c-2.348,1.811-6.242.215-7.456-2.492-1.2-2.678-2.726-5.724,1.515-12.692,3.116-5.119-2.424-11.815-7.271-6.817s-6.933,4.242-5.739-1.969S681.737,366.722,672.755,369.752Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M701.682,421.342l9.12,5.057s8.175-10.052,6.163-14.277-4.456-2.513-4.456-2.513S708.5,417.833,701.682,421.342Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M695.076,415.632s-3.47,4.087-3.248,7.089,5.529,5.74,5.529,5.74l4.325-7.119a23.721,23.721,0,0,1-4.426.645Z",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M599.61,440.893c2.09-1.255,3.672-2.171,2.193-1.947-2.94.445-5.324-1.826-3.968-2.588a12.007,12.007,0,0,1,6.87-1.532c3.66.1,9.535,8.249,9.535,8.249l-3.642,8.554s-1.836-.112-2-.09A70.79,70.79,0,0,1,599.61,440.893Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M597.766,445.078c-2.289-3.01-.063-5.044,1.659-6.194a3.812,3.812,0,0,1,3.455-.166c2.219,1.163,7.718,8.817,6.478,11.917C607.926,454.217,601.738,450.3,597.766,445.078Z",
    fill: "#ffbf9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M687.157,449.722c-2.373,8.4-25.176,24.732-25.176,24.732-21.61,1.047-41.915-14.569-48.86-20.549-1.63-1.4-2.523-2.276-2.523-2.276l3.642-8.554s.867.44,2.3,1.14c4.472,2.179,14.447,6.877,20.817,8.675,11.245,3.165,16.308,6.727,16.308,6.727l1.345-1.634L682.19,424.99C686.151,431.449,687.157,449.722,687.157,449.722Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M655.862,465.413a18.324,18.324,0,0,0-2.2-5.8l1.345-1.634A10.752,10.752,0,0,1,655.862,465.413Z",
    fill: "#28b85e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M616.542,444.214l-3.419,9.69c-1.633-1.4-2.526-2.277-2.526-2.277l3.642-8.552S615.106,443.515,616.542,444.214Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 29.001,
    height: 232.649,
    transform: "translate(566.041 427.151) rotate(-67.406)",
    fill: "#fbae04"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 1.933,
    height: 232.649,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, 574.522, 406.771)",
    fill: "#ef8001",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 1.933,
    height: 232.649,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, 571.241, 414.656)",
    fill: "#ef8001",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 1.933,
    height: 232.649,
    transform: "translate(567.961 422.539) rotate(-67.406)",
    fill: "#ef8001",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 29.001,
    height: 12.166,
    transform: "matrix(0.384, -0.923, 0.923, 0.384, 769.603, 511.86)",
    fill: "#54547e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 29.001,
    height: 6.083,
    transform: "translate(775.219 514.197) rotate(-67.405)",
    fill: "#2c2a40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M791.977,489.759l3.2,1.33a14.5,14.5,0,0,1,7.816,18.959h0a14.5,14.5,0,0,1-18.958,7.816l-3.2-1.33Z",
    fill: "#ff6764"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M566.041,427.151l11.142-26.775-21.286.471-4.427.1-12.51.278,9.238,8.844,3.6,3.445Z",
    fill: "#f6b797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M548.2,410.067a15.093,15.093,0,0,0,2.394-4,10.468,10.468,0,0,0,.879-5.118l-12.511.278Z",
    fill: "#2c2a40"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M734.012,413.255s31.5,20.658,39.237,41.7c0,0-5.334,8.086-12.894,9.2,0,0-19.672-16.728-23.9-27.968C736.458,436.186,730.009,424.245,734.012,413.255Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M773.249,454.956s5.32,10.568-1.9,31.36c-6.481,18.664-21.159,24.55-21.159,24.55l-4.04-9.043s10.668-9.624,12.987-24.39a130.01,130.01,0,0,0,1.217-13.279S765.028,456.459,773.249,454.956Z",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M746.151,494.751s-5.631-2.934-6.371-.874c-.194,1.573.67,3.432,2.884,4.75,0,0-3.5,2.41-2.214,5.7s10.5,9.959,13.5,9.007,6.971-8.666,4.151-12.234S749.448,494.271,746.151,494.751Z",
    fill: "#ffbf9d"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign-up.730a7beb1813611e86e4626edea90516.svg";
export { ForwardRef as ReactComponent };